import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../env';
import { getLocalStorage } from '../utils/function/localStorage';

export const dailyStreakApi = createApi({
  reducerPath: 'dailyStreakApi',
  keepUnusedDataFor: 180,
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('X-Auth-Token', getLocalStorage('tp_Aa_uth_access'));
      return headers;
    },
  }),
  tagTypes: ['dailyStreak'],

  endpoints: (builder) => ({
    getDailyStreakConfig: builder.query({
      query: () => '/secure/getDailyStreakConfig',
      providesTags: ['dailyStreak'],
    }),

    getUserDailyStreakSummary: builder.query({
      query: () => '/secure/getUserDailyStreakSummary',
      providesTags: ['dailyStreak'],
    }),

    claimDailyStreak: builder.mutation({
      query: () => ({
        url: '/secure/claimDailyStreak',
        method: 'POST',
      }),
      invalidatesTags: ['dailyStreak'],
    }),

    getDailyStreakHistory: builder.query({
      query: () => '/secure/getDailyStreakHistory',
      providesTags: ['dailyStreak'],
    }),

    getDailyStreakCalendar: builder.query({
      query: ({ month, year }) => ({
        url: `/secure/getDailyStreakCalendar`,
        method: 'GET',
        params: { month, year },
      }),
      providesTags: ['dailyStreak'],
    }),
  }),
});

export const {
  useGetDailyStreakConfigQuery,
  useGetUserDailyStreakSummaryQuery,
  useClaimDailyStreakMutation,
  useGetDailyStreakHistoryQuery,
  useGetDailyStreakCalendarQuery,
} = dailyStreakApi;
